import showdown from 'showdown';

/* @ngInject */
export default function ($scope, LayoutService, toastr, DataTablesService, $state, moment, $uibModal, Notices, AuthService) {
	AuthService.redirectIfUnauthorized('notice-create', 'splash.home');

	$scope.loading = true;

	LayoutService.setTitle([
		'Notices',
	]);

	let updateButton = LayoutService.getPageHeader()
	                                .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-sync-alt"></i> Update</button>');

	let newButton = LayoutService.getPageHeader()
	                             .setActionButton('<button type="button" class="btn btn-primary pull-right m-r-sm"><i class="fa fa-plus"></i> New Notice</button>');

	LayoutService.getPageHeader()
	             .setBreadcrumbs([
		             {
			             route:       'staff.dashboard',
			             displayName: 'Dashboard',
		             },
		             {
			             route:       'staff.notices.root',
			             displayName: 'Notices',
		             },
	             ]);

	$scope.parseMarkdown = (markdown) => {
		let converter = new showdown.Converter();

		return converter.makeHtml(markdown);
	};

	$scope.dtOptions = DataTablesService.configure({
		title: 'Notices',
	}, {
		order: [
			[
				3,
				'desc',
			],
		],
	}).options;

	$scope.refresh = () => {
		$scope.loading = true;

		Notices.getList()
		       .then((notices) => {
			       $scope.notices = notices;
			       $scope.loading = false;
		       })
		       .catch((error) => {
			       toastr.clear();
			       toastr.error('There was an error while loading the notices list, please try again.', 'Error');

			       $state.go('staff.notices.root');

			       $scope.loading = false;
		       });
	};

	LayoutService.getPageHeader()
	             .onClicked(updateButton, $scope.refresh);

	LayoutService.getPageHeader()
	             .onClicked(newButton, () => {
		             $state.go('staff.notices.new');
	             });

	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/notices/root/controller.js